import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import PromoModal from './components/PromoModal';
import WhatsAppButton from './components/WhatsAppButton';
import { usePromoModal } from './hooks/usePromoModal';
import Home from './pages/Home';
import Enquiry from './pages/Enquiry';
import About from './pages/About';
import Contact from './pages/Contact';
import Menu from './pages/Menu';
import EventsAndMedia from './pages/EventsAndMedia';
import Restaurant from './pages/Restaurant';
import FamilyLounge from './pages/FamilyLounge';
import NightClub from './pages/NightClub';
import CorporateEvent from './pages/CorporateEvent';
import { BarAndLounge, Pub, Hangout, CorporateParty, BirthdayParty, CelebrityAppearance, NightLife, CorporateBusinessLounge } from './pages/FacilityPages';
import { FamilyEvent, FilmshootEvent, FilmshootParty, KittyParty, PreweddingShoot, FamilyParties } from './pages/EventPages';

// Import CSS files
import './assets/css/bootstrap.min.css';
import './assets/css/animate.min.css';
import './assets/css/magnific-popup.css';
import './assets/css/dripicons.css';
import './assets/css/slick.css';
import './assets/css/meanmenu.css';
import './assets/css/default.css';
import './assets/css/style.css';
import './assets/css/responsive.css';
import './components/MobileResponsive.css';
import './components/MobileMenu.css';
import './components/DayWiseBanner.css';

const App: React.FC = () => {
  const { isOpen, closeModal } = usePromoModal();

  return (
    <Router>
      <div className="App">
        <PromoModal isOpen={isOpen} onClose={closeModal} />
        <WhatsAppButton />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/events-and-media" element={<EventsAndMedia />} />
          <Route path="/restaurant" element={<Restaurant />} />
          <Route path="/family-lounge" element={<FamilyLounge />} />
          <Route path="/night-club" element={<NightClub />} />
          <Route path="/corporate-event" element={<CorporateEvent />} />
          <Route path="/corporate-party" element={<CorporateParty />} />
          <Route path="/hangout" element={<Hangout />} />
          <Route path="/pub" element={<Pub />} />
          <Route path="/celebrity-appearance" element={<CelebrityAppearance />} />
          <Route path="/bar-and-lounge" element={<BarAndLounge />} />
          <Route path="/corporate-business-lounge" element={<CorporateBusinessLounge />} />
          <Route path="/night-life" element={<NightLife />} />
          <Route path="/family-event" element={<FamilyEvent />} />
          <Route path="/filmshoot-event" element={<FilmshootEvent />} />
          <Route path="/filmshoot-party" element={<FilmshootParty />} />
          <Route path="/kitty-party" element={<KittyParty />} />
          <Route path="/birthday-party" element={<BirthdayParty />} />
          <Route path="/prewedding-shoot" element={<PreweddingShoot />} />
          <Route path="/family-parties" element={<FamilyParties />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;